// eslint-disable-next-line no-unused-vars
import React from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import slackLogo from '../slack-logo-lite.png'

const loadingCss = css`
  width: 60px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: scale(0.5) rotate(0);
    }

    50% {
      transform: scale(1) rotate(180deg);
    }

    100% {
      transform: scale(0.5) rotate(360deg);
    }
  }
`

const SlackLoader = () => {
  return <img src={slackLogo} alt="Slack loading" css={loadingCss} />
}

export default SlackLoader
